import {PIXI} from '@colonist/pixi'
import {UIGameVoteController} from '../../../../shared/scripts/ui_game/ui_game_vote/UIGameVoteController'
import {VoteView} from '../../../../shared/scripts/ui_canvas_engine/VoteView'
import {UIUtilsEjsVariables} from '../../../../shared/scripts/UIUtilsEjsVariables'

export class UIWGameVoteController extends UIGameVoteController {
    protected showVoteView() {
        if(this.voteView != undefined) this.hideVoteView()
        if(this._activeVote == undefined) return

        const shouldUseMobileView = PIXI.utils.isMobile.any && !UIUtilsEjsVariables.isUserOnDiscordMobile
        const shouldUseMobilePhoneView = PIXI.utils.isMobile.phone && !UIUtilsEjsVariables.isUserOnDiscordMobile

        const chatController = this.uiGameManager.chatController
        const logContainerWidth = chatController.getLogContainerWidth()
        const canvas = this.uiGameManager.canvasController
        const y = 0
        const w = shouldUseMobilePhoneView ? logContainerWidth / 2 : logContainerWidth
        let h = chatController.getLogContainerHeight()
        const x = canvas.appW - w - canvas.margin

        if(shouldUseMobileView) {
            const numPlayers = this._activeVote.participatingPlayers.length
            const widthToHeight4Players = 1.6
            const widthToHeight8Players = 1.25
            h = numPlayers > 4 ? w / widthToHeight8Players : w / widthToHeight4Players
        }

        const voteView = new VoteView(this.uiGameManager, x, y, w, h, this.votes, this._activeVote, () => {
            this.castVote(true, this._activeVote)
        }, () => {
            this.castVote(false, this._activeVote)
        })

        chatController.setLogContainerVisibility(false)
        if(shouldUseMobilePhoneView) chatController.setChatContainerVisibility(false)
        const yStart = canvas.margin
        this.ease.add(voteView, {y: yStart}, {duration: this.TIME.VOTE_ARRIVE, ease: 'easeOutBounce'})
        this.voteView = voteView
    }
}
